export const CHILD_INDENT_PX = 16

export const sidebarRowStyles = (collapsed: boolean, indent: boolean) => ({
  minH: '36px',
  pl: collapsed ? 0 : indent ? `${CHILD_INDENT_PX + 12}px` : 3,
  pr: collapsed ? 0 : 3,
  size: 'sm' as const,
  variant: 'ghost' as const,
  w: '100%',
  justifyContent: collapsed ? 'center' : 'flex-start',
})
